import { PMLineChartCard } from "@pimo/pimo-components/src/lib/pm-components";
import { getLocalizedMessage } from "@pimo/pimo-l10n";

import {
  getCompletedItemsDataAndCategories,
  TIMEFRAME_OPTIONS,
} from "../../../utils/getCompletedItemsByTimeframe";
import { isFieldEnabled } from "../../field-enabled";
import { DashboardCardContext } from "../context";

export function addCompletedCumulativeProjectsLineChartCard(
  ctx: DashboardCardContext
) {
  const { view, projectNamePlural, getCardCopy } = ctx;

  const completedCumulativeProjectsLineChartComponent = view.addComponent({
    component: PMLineChartCard,
    layoutProps: {
      componentId: "completedCumulativeProjectsLineChartComponent",
      title: "",
      description: "",
      labels: [
        "lineChart",
        "chart",
        "completedCumulativeProjectsLineChartComponent",
      ],
    },
  });

  completedCumulativeProjectsLineChartComponent.mapLayoutProps(
    ({ language }) => {
      return {
        componentId: "completedCumulativeProjectsLineChartComponent",
        labels: [
          "lineChart",
          "chart",
          "completedCumulativeProjectsLineChartComponent",
        ],
        title: getCardCopy(language, "completedProjectsOverTimeCumulative")
          .title,
        description: getCardCopy(
          language,
          "completedProjectsOverTimeCumulative"
        ).description,
      };
    }
  );

  completedCumulativeProjectsLineChartComponent.mapState((appState) => {
    const accumulatedCompletedProjectsOverReportingCycle =
      appState?.dashboard?._calculated
        ?.accumulatedCompletedProjectsOverReportingCycle;
    const language = appState?.language;
    const { data, categories } = getCompletedItemsDataAndCategories(
      accumulatedCompletedProjectsOverReportingCycle
    );

    return {
      title: getCardCopy(language, "completedProjectsOverTimeCumulative").title,
      timespans: TIMEFRAME_OPTIONS,
      data,
      categories,
      xLabel: getLocalizedMessage(language, "time") || "Time",
      yLabel: `${getLocalizedMessage(language, "completedPlural")} ${
        projectNamePlural
      }`,
    };
  });

  completedCumulativeProjectsLineChartComponent.mapVisibility(({ settings }) =>
    isFieldEnabled(settings, "completion", "itemReporting")
  );
}
